import { createSlice } from "@reduxjs/toolkit";
import { ErrorType, RootState } from "../../../app/store";
import {
    PMDepositsDebitsDetail,
    DepositsDebitsDTO,
    DepositSearchTransactionResponseDto,
    DepositTransactionsDto
} from "@inosio/payments-sdk";

interface ITransDataPage {
    Rows: Array<PMDepositsDebitsDetail>;
}

type PMState = {
    DepositsHistory: DepositsDebitsDTO;
    DepositsDataPages: Array<ITransDataPage>;
    isfetching: boolean,
    isSuccessful:boolean,
    depositTrans: Array<DepositSearchTransactionResponseDto>,
    depositTransDataBook: Array<DepositTransactionsDto>
    error: ErrorType,
    isFetchingDeposits: boolean;

};

const getInitialState = () => {
    return {
        DepositsHistory: { TotalCount: 0, RecordStart: 0, RangeSize: 100, Rows: [] },
        DepositsDataPages: [],
        isfetching:false,
        isSuccessful:true,
        depositTrans:[],
        depositTransDataBook:[],
        error: {} as ErrorType,
        isFetchingDeposits: false
    } as PMState
};

const pmTransactionsSlice = createSlice({
    name: "pmDepositsReducer",
    initialState: getInitialState(),
    reducers: {
        getDepositsHistoryPage(state, action) {

        },
        getDepositsHistoryDetails(state, action) {
            state.isFetchingDeposits = true;
            state.error = {} as ErrorType
        },
        setDepositsHistoryDetails(state, action) {

            /*
            this function has one responsiblity: receive updates from API
            and put the results in state.
            */
            let _payload = action.payload as DepositsDebitsDTO;

            //get a copy of the current book
            let currentDepositsPages = [...state.DepositsDataPages];

            //if startindex = 0, just reset the book because that means it's loading for the first time or he reset the range size
            if (_payload.RecordStart === 0)
                currentDepositsPages = [];

            //find out what page we are on
            let whatPageResultsIsThis = Math.ceil(
                _payload.RecordStart / _payload.RangeSize
            );

            //now, add this new data page to our book
            currentDepositsPages[whatPageResultsIsThis] = {
                Rows: _payload.Rows,
            };

            //return the full
            let depositsHistoryDetailsData = {
                DepositsHistory: action.payload,
                DepositsDataPages: currentDepositsPages,
                isFetchingDeposits: false
            };

            return { ...state, ...depositsHistoryDetailsData };
        },
        setDepositsHistoryDetailsExport(state){
            state.isFetchingDeposits=false;
        },
        getDepositTransactions(state,action){
            state.isfetching=true
        },
        setDepositTransactions(state,action){
            state.isfetching=false;
            state.isSuccessful=true;
            let obj=[...state.depositTrans,...action.payload.Rows];
            state.depositTrans=obj
            let transBook= [...state.depositTransDataBook, action.payload]
            state.depositTransDataBook= transBook

        },
        setDepositsError(state, action){
            state.isFetchingDeposits = false;
            state.error=action.payload
        }
    },
});

export const { 
    getDepositsHistoryDetails,
    setDepositsHistoryDetails,
    getDepositTransactions,
    setDepositTransactions,
    setDepositsError,
    setDepositsHistoryDetailsExport
} =
    pmTransactionsSlice.actions;

export default pmTransactionsSlice.reducer;

export const selectDepositsHistoryDetails = (state: RootState) =>
    state.pmDpModuleState.DepositsHistory;

export const selectDepositsHistoryDetailsCurrentPage = (state: RootState) =>
    state.pmDpModuleState.DepositsDataPages;

export const selectDepositTransactions=(state: RootState)=>
    state.pmDpModuleState.depositTransDataBook

    export const selectDepositTransactionsState=(state: RootState)=>
    state.pmDpModuleState
